/* eslint-disable @typescript-eslint/no-unused-vars */
import React, {useEffect, useRef, useState} from "react";
import {customControlProps} from "components/common/modules/video-player/video";
import * as InstaControl from "../styles/v3-insta-video-control-style";
import {Cpds} from "@Cpds.Ui";
import {css} from 'styled-components';
import {checkValue} from "components/functions";

type InstaVideoControlProps = customControlProps &{
  authorUrl?: string;
  openUrlInNewTab?: boolean;
}

const InstaVideoControl: React.FC<InstaVideoControlProps> = (props) => {

  const {
    togglePlay,
    isPlaying,
    togglePlaysound,
    togglePlayWithSound,
    hideSoundControlsForVideo,
    isMuted,
    progress,
    currentTime,
    themeTokens,
    authorUrl,
    openUrlInNewTab,
    withSounds
  } = props;

  const [buttonVisible, setButtonVisible] = useState(true);
  const timeoutRef = useRef(null);

  const togglePlayPause = () => {

    if (withSounds) {
      togglePlayWithSound();
    } else {
      togglePlay();
    }

    setButtonVisible(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      !isPlaying && setButtonVisible(false);
    }, 3000); // Hide button after 3 seconds
  };

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return (

    <>
      <InstaControl.Container className="v3-insta-video-control" buttonVisible={buttonVisible}>
        {checkValue(authorUrl) && <Cpds.Button target={openUrlInNewTab ? '_blank': '_self'} tag="a" href={authorUrl} buttonSize={'medium'} styleOverrides={css`
          background-color: #262626;
          width: 20px !important;
          height: 20px !important;
          &:focus {
            border: none;
          }
        `}>
          <Cpds.Icon name="person" id="account" color="#FFFFFF" customSize={{width: '10', height: '10'}}
                     styleOverrides={css`
                       path {
                         fill: #FFFFFF !important;
                       }
                     `}/>
        </Cpds.Button>}

        <Cpds.Button
          buttonType='Primary' tag="button" onClick={togglePlaysound}
          styleOverrides={css`
            background-color: #262626;
            margin-left: auto;
            min-width: 20px !important;
            width: 20px !important;
            height: 20px !important;
            &:focus {
              border: none;
              &:after {
              border: none;
            }
            }
          `}
        >
          <Cpds.Icon name={isMuted ? "volume-mute-filled" : "volume-filled"} id="volume"
                     customSize={{width: '10', height: '10'}} color="#FFFFFF"
                     styleOverrides={css`
                       path {
                         fill: #FFFFFF !important;
                       }
                     `}/>
        </Cpds.Button>
      </InstaControl.Container>
    </>
  )
}


export default InstaVideoControl;